
import { Navigate } from 'react-router-dom';

export const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('token'); // You can enhance this check based on your needs

  return isAuthenticated ? children : <Navigate to="/login" />;
};